import Account from '../headerIcons/account';
import Back from '../headerIcons/back';
import Menu from '../headerIcons/menu';
import Quikr from '../headerIcons/quikr';
import Gps from '../headerIcons/gps';

export { Account, Back, Menu, Quikr, Gps };



// WEBPACK FOOTER //
// ../q-components/components/icons/headerIcons/index.js